<!-- HEADER -->
<div class="mb-6 flex items-center justify-between gap-4">
	<div class="text-base font-bold text-black">
		{{ name }} [<span class="text-violet">{{ staffNumber }}</span
		>]
	</div>
	<div class="flex items-center gap-3 font-medium text-grey-40">
		<span (click)="goBack()" class="cursor-pointer text-red">Pilot Data Management</span>
		<span>></span>
		<span>Folders</span>
	</div>
</div>

<!-- GRID -->
<div class="grid grid-cols-4 gap-6">
	@for (folder of folders; track folder.id; let i = $index) {
		<div
			(click)="viewFiles(folder)"
			class="flex cursor-pointer flex-col items-center rounded-lg bg-blue-10 px-2 py-8 hover:shadow-lg"
		>
			@if (!folderIsEmpty(folder)) {
				<img src="./assets/icon_folder.svg" alt="Folder icon" class="mb-2 h-12 w-12" />
			} @else {
				<img src="./assets/icon_folder_empty.svg" alt="Empty folder icon" class="mb-2 h-12 w-12" />
			}

			<div class="line-clamp-1 text-center text-sm font-medium text-gray-800">
				{{ folder.id.toString().padStart(2, "0") }}. {{ folder.name }}
			</div>
		</div>
	}
</div>

<!-- Loading state -->
@if (folders.length === 0) {
	<div class="flex items-center justify-center py-12">
		<div class="text-gray-500">Loading folders...</div>
	</div>
}

<div class="mt-6 flex items-center justify-between gap-4 border-t border-blue-20 pt-4">
	<button (click)="goBack()" class="aa-btn" data-variant="tertiary">Back</button>
	<button (click)="uploadData(staffNumber!)" class="aa-btn" data-variant="primary">Upload</button>
</div>
